import { useApiClient } from '../../../hooks/useApiClient';
import { IRepresentanteReceber } from '../../../interfaces/IRepresentante';

export const URL_REPRESENTANTES = '/dief-cfem/api/usuario/representantes';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getRepresentantes = async (page: number, size: number = 50, cpfCnpjFiltro: string = '') => {
    const resposta = await httpCall.get<IRepresentanteReceber>(
      `${URL_REPRESENTANTES}?page=${page}&size=${size}&cpf_cnpj_filtro=${cpfCnpjFiltro}`
    );

    return resposta.data;
  };
  return {
    getRepresentantes,
  };
};
